import { render } from "./DeviationCrewCountInput.vue?vue&type=template&id=edc31aaa"
import script from "./DeviationCrewCountInput.vue?vue&type=script&lang=ts"
export * from "./DeviationCrewCountInput.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QInput});
